export default __webpack_public_path__ + "static/illustration-business.url-96a2383e3463e1f932fbb3b8a193bf9e.svg";